// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.U8HZBhZ08YtgzAkc{margin:0 4px;flex-shrink:0}.W68Rns1qpeEue0tj{height:264px;border:1px solid var(--py-neutral-2);border-radius:4px}.N8LHwuV9CpECpIy8{border-bottom:1px solid var(--py-neutral-2)}.N8LHwuV9CpECpIy8 .ZMntQ6M8H8LH0BoU{border-width:0;color:var(--py-neutral-3);background-color:rgba(0,0,0,0)}.N8LHwuV9CpECpIy8 .ZMntQ6M8H8LH0BoU:hover{color:var(--py-neutral-6);cursor:pointer}.N8LHwuV9CpECpIy8 .ZMntQ6M8H8LH0BoU:active{color:var(--py-neutral-7)}.N8LHwuV9CpECpIy8 .U6VPMPFXAFQDkMoL{padding-right:0px}.N8LHwuV9CpECpIy8 .covoaeBdnQg0tyEg{min-width:0px;padding:0px}.N8LHwuV9CpECpIy8 .U97pDYdt90yjONSl{border-radius:8px;padding:8px;background-color:var(--py-neutral-1)}.H88s9LHSiAotdbdM{max-width:416px !important}.apDSkjE244TPiTAN{height:14px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleAvatar": `U8HZBhZ08YtgzAkc`,
	"trendlineChartPlaceholder": `W68Rns1qpeEue0tj`,
	"FieldHistoryItem": `N8LHwuV9CpECpIy8`,
	"iconButton": `ZMntQ6M8H8LH0BoU`,
	"updaterAvatar": `U6VPMPFXAFQDkMoL`,
	"actionLink": `covoaeBdnQg0tyEg`,
	"commentBox": `U97pDYdt90yjONSl`,
	"formModal": `H88s9LHSiAotdbdM`,
	"titleImage": `apDSkjE244TPiTAN`
};
export default ___CSS_LOADER_EXPORT___;
